import { UserEventStatus } from "../../enums";

/**
 * Statuses that should be excluded from reservation counts.
 * These represent cancelled, penalty-cancelled, or paid-but-not-attended reservations.
 */
export const EXCLUDED_RESERVATION_STATUSES: UserEventStatus[] = [
  UserEventStatus.PenaltyCancelled,
  UserEventStatus.OnlyPaid,
];

/**
 * Checks if a reservation should be considered as effectively cancelled.
 * This includes both the isCancelled flag and specific statuses like PenaltyCancelled and OnlyPaid.
 *
 * @param isCancelled - The isCancelled flag from the reservation
 * @param status - The UserEventStatus of the reservation
 * @returns true if the reservation is effectively cancelled
 */
export const isReservationCancelled = (
  isCancelled: boolean,
  status: UserEventStatus
): boolean => {
  return isCancelled || EXCLUDED_RESERVATION_STATUSES.includes(status);
};

/**
 * Checks if a reservation is active (should be counted in space calculations).
 * A reservation is active if it's not cancelled and not in an excluded status.
 *
 * @param isCancelled - The isCancelled flag from the reservation
 * @param status - The UserEventStatus of the reservation
 * @returns true if the reservation is active and should be counted
 */
export const isReservationActive = (
  isCancelled: boolean,
  status: UserEventStatus
): boolean => {
  return !isReservationCancelled(isCancelled, status);
};
